import { render, staticRenderFns } from "./OrderTeacher.vue?vue&type=template&id=1e8dd7a8&scoped=true"
import script from "./OrderTeacher.vue?vue&type=script&lang=js"
export * from "./OrderTeacher.vue?vue&type=script&lang=js"
import style0 from "./OrderTeacher.vue?vue&type=style&index=0&id=1e8dd7a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8dd7a8",
  null
  
)

export default component.exports